/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AppInsightsEffects } from './app-insights.effects';
import { featureKey } from './app-insights.selectors';
import { appInsightsReducer } from './app-insights.reducer';

/**
 * @description NgRx module for App Insights store management
 */
@NgModule({
    imports: [
        StoreModule.forFeature(featureKey, appInsightsReducer),
        EffectsModule.forFeature([AppInsightsEffects]),
    ],
})
export class AppInsightsStoreModule {}
